(function () {
  'use strict';

  var CART_DRAWER_ID = 'CartDrawer';

  function onVariantChange(e) {
    if (e.target.id !== 'free-gift-variant-select') return;
    var section = e.target.closest('#free-gift-section');
    var btn = section && section.querySelector('.free-gift-add-button');
    if (btn) btn.setAttribute('data-variant-id', e.target.value);
  }

  function resetButton(button, buttonTextEl, loadingEl, label) {
    if (button) button.disabled = false;
    if (loadingEl) loadingEl.classList.add('hidden');
    if (buttonTextEl) {
      buttonTextEl.classList.remove('hidden');
      buttonTextEl.textContent = label;
    }
  }

  function setButtonLoading(button, buttonTextEl, loadingEl) {
    button.disabled = true;
    if (buttonTextEl) buttonTextEl.classList.add('hidden');
    if (loadingEl) loadingEl.classList.remove('hidden');
  }

  function onAddFreeGiftClick(e) {
    var button = e.target.closest('.free-gift-add-button');
    if (!button || !button.closest('#' + CART_DRAWER_ID)) return;

    e.preventDefault();
    e.stopPropagation();

    var variantId = button.getAttribute('data-variant-id');
    var buttonTextEl = button.querySelector('.free-gift-button-text');
    var loadingEl = button.querySelector('.free-gift-loading');
    var wrapper = button.closest('#cart-progress-wrapper');
    var fallbackLabel = (wrapper && wrapper.getAttribute('data-free-gift-button-text')) || 'Add Free Gift';

    if (!variantId) return;

    setButtonLoading(button, buttonTextEl, loadingEl);

    var sectionsUrl = (typeof window.location !== 'undefined' && window.location.pathname) || '/';
    var payload = {
      items: [
        {
          id: parseInt(variantId, 10),
          quantity: 1,
          properties: { _free_gift: 'true' }
        }
      ],
      sections: ['cart-drawer', 'cart-icon-bubble'],
      sections_url: sectionsUrl
    };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Add to cart failed');
        return res.json();
      })
      .then(function (data) {
        var cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && typeof cartDrawer.renderContents === 'function' && data.sections) {
          cartDrawer.renderContents(data);
        } else {
          var section = document.getElementById('free-gift-section');
          if (section) section.style.display = 'none';
          resetButton(button, buttonTextEl, loadingEl, fallbackLabel);
        }
      })
      .catch(function (err) {
        console.error('Free gift add error:', err);
        resetButton(button, buttonTextEl, loadingEl, fallbackLabel);
        if (buttonTextEl) {
          buttonTextEl.textContent = 'Error – Try Again';
          buttonTextEl.classList.remove('hidden');
          setTimeout(function () { buttonTextEl.textContent = fallbackLabel; }, 2000);
        }
      });
  }

  function init() {
    document.addEventListener('change', onVariantChange);
    document.addEventListener('click', onAddFreeGiftClick);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
